import { render, staticRenderFns } from "./UnconsideredPlatesListComponent.vue?vue&type=template&id=5bf286ee&scoped=true"
import script from "./UnconsideredPlatesListComponent.vue?vue&type=script&lang=js"
export * from "./UnconsideredPlatesListComponent.vue?vue&type=script&lang=js"
import style0 from "./UnconsideredPlatesListComponent.vue?vue&type=style&index=0&id=5bf286ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf286ee",
  null
  
)

export default component.exports